import { Component, Input } from '@angular/core';
import { TranslocoService, TranslocoPipe } from '@jsverse/transloco';
import { ExtendedOrderType } from '../../../core/enums';
import { SearchResult } from '../../../core/models';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-merchant-popover',
    standalone: true,
    imports: [TranslocoPipe, RouterLink],
    templateUrl: './merchant-popover.component.html',
    styleUrls: ['./merchant-popover.component.css'],
})
export class MerchantPopoverComponent {
  @Input() merchant: SearchResult;

	ExtendedOrderType = ExtendedOrderType;

  constructor(public translate: TranslocoService) { }

}
